import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsLprFilterVehicleAttributes extends SnModel {
  @Expose()
  public colors: string[];

  @Expose()
  public makes: string[];

  @Expose()
  public types: string[];

  constructor(data = {}) {
    super();
    this.fromJSON(data);
  }
}
